module.exports = __webpack_public_path__ + "static/image5-d2bbfe86c1070a6c8142750cc5fba301.jpg";